import { useEffect } from "react"

export default function useHandleKeyPress(callback) {
  useEffect(() => {
    if (callback && typeof callback === "function") {
      window.addEventListener("keydown", callback)
    }
    return () => {
      if (callback && typeof callback === "function") {
        window.removeEventListener("keydown", callback)
      }
    }
  }, [callback])
}
